import { PermissionEnum } from '@sr-sdks/api-sdk-axios';
import { useEffect } from 'react';
import { Outlet, useLocation, useParams } from 'react-router-dom';
import BankDetailSideOverlay from '../components/BankDetails/BankDetailSideOverlay';
import { AppLoader } from '../components/Loader';
import ProtectElement from '../components/ProtectElement';
import AppTabMenu from '../components/navigation/AppTabMenu';
import { workspaceService } from '../reducers/workspaces/workspaceSlice';
import { useAppDispatch, useTypedSelector } from '../stateStore';
import { isLoadingState } from '../utils/helpers/common';
import DefaultLayoutV3 from './DefaultLayoutV3';

const ManageWorkspaceTab = () => {
  const dispatch = useAppDispatch();

  const { workspaceId } = useParams<{ workspaceId: string }>();
  const { pathname } = useLocation();

  const isLoading = useTypedSelector(workspaceService.selectors.isLoading);
  const isWorkspaceRootPath = pathname.startsWith('/workspace/');
  const getTabLink = (path: string) =>
    pathname.startsWith('/workspace/') && workspaceId
      ? `/workspace/${workspaceId}/manage-workspace/${path}`
      : path;

  useEffect(() => {
    if (!workspaceId) return;

    dispatch(workspaceService.findOne(workspaceId));
  }, [dispatch, workspaceId]);

  if (isLoadingState(isLoading)) {
    return <AppLoader.FlexLoader />;
  }

  return (
    <BankDetailSideOverlay>
      <DefaultLayoutV3.Content>
        <AppTabMenu.Group className="w-full">
          <ProtectElement
            permissionRequired={[PermissionEnum.EditWorkspaceDetails]}
            workspaceId={workspaceId}
          >
            <AppTabMenu.Item label="Details" linkTo={getTabLink('details')} />
          </ProtectElement>
          <ProtectElement
            permissionRequired={[PermissionEnum.EditBankDetails]}
            workspaceId={workspaceId}
          >
            <AppTabMenu.Item
              label="Bank Account"
              linkTo={getTabLink('bank-account')}
            />
          </ProtectElement>
          <ProtectElement
            permissionRequired={[PermissionEnum.EditTeammates]}
            workspaceId={workspaceId}
          >
            <AppTabMenu.Item
              label="Teammates"
              linkTo={getTabLink('teammates')}
            />
          </ProtectElement>
        </AppTabMenu.Group>

        <Outlet context={{ workspaceId }} />
      </DefaultLayoutV3.Content>
    </BankDetailSideOverlay>
  );
};

export default ManageWorkspaceTab;
